(function () {
    'use strict';

    angular
        .module('telestatApp')
        .factory('CianHistoryLoader', CianHistoryLoader);

    CianHistoryLoader.$inject = ['$resource', 'DateUtils'];

    function CianHistoryLoader($resource, DateUtils) {
        var service = $resource('api/pbx/cian/load-history', {}, {
            'loadHistory': {
                method: 'POST'
            },
            'retransmissionHistory': {
                method: 'POST',
                url: 'api/pbx/cian/retransmission-signals'
            }
        });

        return service;
    }

    angular
        .module('telestatApp')
        .factory('MegafonHistoryLoader', MegafonHistoryLoader);

    MegafonHistoryLoader.$inject = ['$resource', 'DateUtils'];
    
    function MegafonHistoryLoader($resource, DateUtils) {
        var service = $resource('api/pbx/megafon/load-history', {}, {
            'loadHistory': {
                method: 'POST'
            },
            'retransmissionHistory': {
                method: 'POST',
                url: 'api/pbx/megafon/retransmission-signals'
            }
        });

        return service;
    }

})();
